import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface QuoteIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const QuoteIcon = ({ className, ...props }: QuoteIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 12L19 12C19.5523 12 20 12.4477 20 13L20 16.5C20 17.0523 19.5523 17.5 19 17.5L15 17.5C14.4477 17.5 14 17.0523 14 16.5L14 12ZM14 12C14 9.5 15 8 18 6.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M4 12L9 12C9.55229 12 10 12.4477 10 13L10 16.5C10 17.0523 9.55228 17.5 9 17.5L5 17.5C4.44772 17.5 4 17.0523 4 16.5L4 12ZM4 12C4 9.5 5 8 8 6.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default QuoteIcon;
